import { render, staticRenderFns } from "./order-screen.vue?vue&type=template&id=2df4a63b"
import script from "./order-screen.vue?vue&type=script&lang=js"
export * from "./order-screen.vue?vue&type=script&lang=js"
import style0 from "./order-screen.vue?vue&type=style&index=0&id=2df4a63b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports